@if (project && !loading) {
    <div class="tw-flex tw-row md:tw-grid-cols-3 tw-items-start">
        <mat-card
            class="tw-ml-4 tw-max-w-32 tw-flex tw-flex-col tw-gap-2 tw-col-span-5 lg:tw-col-span-4 2xl:tw-col-span-3 lg:tw-col-start-2 2xl:tw-col-start-2 tw-min-w-[825px]"
        >
            <mat-card-header
                class="tw-flex tw-justify-between tw-items-center tw-mb-2"
            >
                <mat-card-title class="tw-font-medium">
                    Project: {{ project.name }}

                    <div id="hourInformation" class="tw-text-sm">
                        <div id="totalHours" class="tw-flex-grow">
                            <div class="tw-font-bold tw-inline tw-mr-1">
                                Hours:&nbsp;
                            </div>
                            <div class="tw-inline">
                                {{
                                    project.estimatedHours ??
                                        "Estimated Hour Allocation Missing"
                                }}
                            </div>
                        </div>
                        <div
                            id="remainingHours"
                            class="tw-inline-flex tw-items-center"
                        >
                            <div class="tw-font-bold tw-mr-1">
                                Hours Remaining:&nbsp;
                            </div>
                            <div
                                class="tw-inline-flex tw-items-center tw-align-middle"
                            >
                                @if (
                                    project.totalProjectHours?.hoursWorked >
                                        0 && project.estimatedHours
                                ) {
                                    {{
                                        projectHoursRemaining() ??
                                            "Hours Could Not be Calculated (Unknown Error)"
                                    }}
                                } @else {
                                    <div class="tw-inline">
                                        Insufficient Data
                                    </div>
                                }
                                @if (calculatingHours) {
                                    <mat-spinner diameter="12"></mat-spinner>
                                }
                            </div>
                        </div>

                        <div id="totalHoursWorked" class="tw-flex-grow">
                            <div class="tw-font-bold tw-inline tw-mr-1">
                                Total Hours Worked:&nbsp;
                            </div>
                            <div class="tw-inline">
                                {{
                                    project.totalProjectHours.hoursWorked ??
                                        "No Hours Against Project "
                                }}
                            </div>
                        </div>
                    </div>
                </mat-card-title>
                <button mat-icon-button>
                    <mat-icon class="tw-m-0 m3-error">close</mat-icon>
                </button>
            </mat-card-header>
            <mat-card-content class="tw-grid tw-grid-flow-row tw-gap-2">
                <mat-card class="tw-gap-2">
                    <mat-card-header
                        class="tw-flex tw-justify-between tw-items-center tw-mb-2"
                    >
                        <mat-card-title>
                            {{ tasks.length > 0 ? "Tasks" : "No Tasks" }}
                        </mat-card-title>
                    </mat-card-header>
                    @if (tasks.length > 0) {
                        <mat-card-content>
                            <div>
                                <table
                                    mat-table
                                    class="tw-w-full tw-bg-transparent"
                                    [dataSource]="getDataSource()"
                                    matSort
                                >
                                    <ng-container matColumnDef="name">
                                        <th
                                            mat-header-cell
                                            *matHeaderCellDef
                                            mat-sort-header="name"
                                            class="tw-w-fit"
                                            [disabled]="dontSort('name')"
                                        >
                                            Name
                                        </th>
                                        <td
                                            mat-cell
                                            *matCellDef="let task"
                                            class="tw-break-all tw-w-fit"
                                            [ngClass]="
                                                task.name.length < 40
                                                    ? 'tw-text-nowrap'
                                                    : 'tw-text-wrap'
                                            "
                                        >
                                            {{ task.name }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="billType">
                                        <th
                                            mat-header-cell
                                            *matHeaderCellDef
                                            mat-sort-header
                                            class="tw-w-fit tw-text-nowrap tw-items-center"
                                            [disabled]="dontSort('billType')"
                                        >
                                            Bill Type
                                        </th>
                                        <td mat-cell *matCellDef="let task">
                                            {{ task.billType }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="action">
                                        <th
                                            mat-header-cell
                                            *matHeaderCellDef
                                            class="tw-w-fit"
                                        ></th>
                                        <td mat-cell *matCellDef="let task">
                                            <div
                                                class="tw-flex tw-justify-center"
                                            >
                                                @if (task.status === "ACTIVE") {
                                                    <button
                                                        mat-raised-button
                                                        class="m3-error tw-m-auto"
                                                        (click)="
                                                            removeTask(task)
                                                        "
                                                    >
                                                        Deactivate
                                                    </button>
                                                } @else {
                                                    <button
                                                        mat-raised-button
                                                        (click)="
                                                            makeTaskActive(task)
                                                        "
                                                    >
                                                        Activate
                                                    </button>
                                                }
                                            </div>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="edit">
                                        <th
                                            mat-header-cell
                                            *matHeaderCellDef
                                            class="tw-w-fit tw-pl-0"
                                        ></th>
                                        <td
                                            mat-cell
                                            class="tw-w-fit tw-pl-0"
                                            *matCellDef="let task"
                                        >
                                            <button
                                                mat-button
                                                (click)="editTask(task)"
                                            >
                                                <mat-icon class="tw-m-0">
                                                    edit
                                                </mat-icon>
                                            </button>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="users">
                                        <th
                                            mat-header-cell
                                            *matHeaderCellDef
                                            mat-sort-header="users"
                                            class="tw-w-fit tw-p-0"
                                            [disabled]="dontSort('users')"
                                        >
                                            Users
                                        </th>
                                        <td
                                            mat-cell
                                            *matCellDef="let task"
                                            class="tw-w-fit tw-p-0"
                                        >
                                            <div class="tw-flex tw-flex-col">
                                                @for (
                                                    user of task.taskUsers;
                                                    track $index
                                                ) {
                                                    @if ($index < 3) {
                                                        <div
                                                            class="tw-inline tw-whitespace-nowrap"
                                                        >
                                                            @if (
                                                                $index === 2 &&
                                                                task.taskUsers
                                                                    .length > 3
                                                            ) {
                                                                {{
                                                                    userConcatName(
                                                                        user,
                                                                        $index
                                                                    )
                                                                }}
                                                                <!--
                                                                toSpliced Logic:
                                                                Remove $index + 1 users: (3 users) starting at index 0
                                                                This gives us the rest of the users in an array to be displayed in the tooltip menu
                                                                -->
                                                                <div
                                                                    class="tw-inline"
                                                                    id="tooltip{{
                                                                        task.id
                                                                    }}"
                                                                    [matTooltip]="
                                                                        tooltipText(
                                                                            task.taskUsers.toSpliced(
                                                                                0,
                                                                                $index +
                                                                                    1
                                                                            ),
                                                                            $index +
                                                                                1
                                                                        )
                                                                    "
                                                                    matTooltipPosition="below"
                                                                    matTooltipClass="tw-whitespace-pre-line tw-right-10"
                                                                    [style.display]="
                                                                        !flippedIndices[
                                                                            task
                                                                                .id
                                                                        ] ===
                                                                        true
                                                                            ? 'inline'
                                                                            : 'none'
                                                                    "
                                                                >
                                                                    ...
                                                                </div>
                                                            } @else {
                                                                {{
                                                                    userConcatName(
                                                                        user,
                                                                        $index
                                                                    )
                                                                }}
                                                            }
                                                        </div>
                                                    } @else {
                                                        <div
                                                            class="tw-inline tw-whitespace-nowrap"
                                                            [style.display]="
                                                                flippedIndices[
                                                                    task.id
                                                                ] === true
                                                                    ? 'block'
                                                                    : 'none'
                                                            "
                                                        >
                                                            {{
                                                                userConcatName(
                                                                    user,
                                                                    $index
                                                                )
                                                            }}
                                                        </div>
                                                    }
                                                }
                                            </div>
                                        </td>
                                    </ng-container>

                                    <ng-container
                                        matColumnDef="additionalUsers"
                                    >
                                        <th
                                            mat-header-cell
                                            *matHeaderCellDef
                                            class="tw-w-fit"
                                        ></th>
                                        <td
                                            mat-cell
                                            *matCellDef="let task"
                                            class="tw-w-fit"
                                        >
                                            @if (task.taskUsers.length > 3) {
                                                <button
                                                    mat-icon-button
                                                    (click)="
                                                        toggleFlip(task.id)
                                                    "
                                                >
                                                    <mat-icon
                                                        [id]="task.id"
                                                        [ngClass]="{
                                                            'tw-transition-transform tw-rotate-180 tw-duration-200':
                                                                flippedIndices[
                                                                    task.id
                                                                ]
                                                        }"
                                                        [fontIcon]="
                                                            'keyboard_arrow_down'
                                                        "
                                                    ></mat-icon>
                                                </button>
                                            }
                                        </td>
                                    </ng-container>

                                    <tr
                                        mat-header-row
                                        *matHeaderRowDef="displayedColumns"
                                    ></tr>
                                    <tr
                                        mat-row
                                        *matRowDef="
                                            let row;
                                            columns: displayedColumns
                                        "
                                    ></tr>
                                </table>
                            </div>
                        </mat-card-content>
                    }
                </mat-card>
            </mat-card-content>
        </mat-card>
    </div>
}
